<script lang="ts">
    import PanelistDashboardPage from '@Evaluation/Estimations/Pages/PanelistDashboardPage'
    export default PanelistDashboardPage
</script>

<template>
    <div>
        <AlternativeDetailsDialog :viewModel="alternativeDetailsDialog" />

        <div v-if="!initialized" class="container">
            <h3 class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
        </div>

        <div v-if="initialized && IsClosed" class="d-flex justify-content-center" style="padding-top: 200px;">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Survey is closed</h5>
                    <p class="card-text lead">Please wait for the host to open this survey or go to the meeting.</p><br />
                    <a class="btn btn-secondary" v-sanitizedHref="MeetingUrl">Go to the meeting</a>
                </div>
            </div>
        </div>

        <div v-if="initialized && !IsClosed && SurveyQuestionsCount === 0" class="d-flex justify-content-center" style="padding-top: 200px;">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Empty survey: {{SurveyName}}</h5>
                    <p class="card-text lead">Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.</p>
                </div>
            </div>
        </div>

        <div v-if="initialized && !IsClosed && SurveyQuestionsCount > 0">

            <nav class="navbar navbar-expand-md navbar-dark bg-dark">
                <div class="container">

                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <a class="btn btn-light mr-2" v-sanitizedHref="MeetingUrl">Join Meeting</a>

                        <div class="btn-group mr-2" role="group">
                            <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown">
                                My votes
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="downloadVotes">Download to xls</a>
                            </div>
                        </div>

                        <a class="btn btn-light" href="https://www.transparentchoice.com/user-guide/respondents-scoring" title="Respondents guide: Scoring Projects" target="_blank">
                            <i class="fa fa-info" aria-hidden="true"></i>
                        </a>
                    </form>

                </div>
            </nav>

            <div class="container">
                <h3 class="mt-5 font-weight-light">Survey: {{SurveyName}}</h3>
                <p>
                    Assesss {{Alternatives.length}} <span class="text-lowercase">{{AlternativesLabel}}</span>
                    by answering {{SurveyQuestionsCount}} questions.
                </p>
                <p class="lead">{{SurveyDescription}}</p>
                <br />

                <nav class="navbar navbar-expand-md navbar-light bg-light">
                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <input class="form-control mr-sm-2" type="search" placeholder="Search..." v-model="SearchPhrase">
                    </form>
                </nav>

                <table class="table table-hover mt-3">
                    <thead>
                        <tr>
                            <th>
                                {{AlternativeLabel}}
                            </th>
                            <th>
                                <a class="pointer" @click="ToggleOrderByProgressCommand">
                                    Progress
                                </a>
                            </th>
                            <th style="width: 120px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="a in AlternativesView" :key="a.AlternativeId">
                            <td>
                                <a class="text-dark" @click="showAlternativeDetails(a)">{{a.Name}}</a>
                            </td>
                            <td class="text-center">
                                <div class="progress" style="height: 30px;">
                                    <div class="progress-bar" role="progressbar" :style="{width: a.Progress + '%'}"></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <a class="btn btn-outline-primary" v-sanitizedHref="a.EvaluationUrl">Evaluate</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </div>

</template>
